import irelandApi from '../irelandApi';

export const getFeatures = () => dispatch =>
  irelandApi
    .get('/api/features')
    .then(({ data }) =>
        dispatch({ type: 'FEATURES_LOADED', payload: data })
    )
    .catch(error => dispatch({ type: 'FEATURES_FAILED' }));



// WEBPACK FOOTER //
// ./src/actions/features.js